import React from 'react';
import PropTypes from 'prop-types';
import DataExportOptions from './children/options';
import {
  statusMap,
  validStatusesForDownload,
  receiptStatuses,
} from '../constants';

const DataExport = (props) => {
  const isCostClickable = () => {
    const {
      status,
    } = props;
    return (status && receiptStatuses.includes(status));
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    const { openDeleteExportModal, id } = props;
    openDeleteExportModal(id);
  };

  const handleReceiptClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { braintreeId, openTab } = props;
    if (isCostClickable() && braintreeId) {
      openTab(`/v2/account/invoice/${braintreeId}`, e);
    }
  };

  const validStatusForDownload = status => status in validStatusesForDownload;

  const handleDownload = (e) => {
    e.stopPropagation();
    if (validStatusForDownload(props.status)) {
      props.downloadAsCSV(props.id);
    }
  };

  const handleRecap = (e) => {
    e.stopPropagation();
    const { id, navigateTo } = props;
    navigateTo(`/data-exports/history/${id}`);
  };

  const toggleOpen = (e) => {
    e.stopPropagation();
    const { index, exportsOptionsOpen, optionsCanOpen } = props;
    const hasOptionsOpen = (index === exportsOptionsOpen);
    if (hasOptionsOpen) { // this export is currently selected
      props.openOption(NaN);// close the option
    } else if (optionsCanOpen) {
      props.openOption(props.index);
    }
  };

  const renderOptions = (hasOptionsOpen) => {
    if (hasOptionsOpen) {
      const costClickable = isCostClickable();
      const { status } = props;
      return (
        <DataExportOptions
          isCostClickable={costClickable}
          handleReceiptClick={handleReceiptClick}
          handleDeleteClick={handleDeleteClick}
          handleDownload={handleDownload}
          handleRecap={handleRecap}
          downloadClickable={validStatusForDownload(status)}
        />
      );
    }
    return null;
  };

  const {
    dateCreated, cost, exportType, status, index, exportsOptionsOpen,
  } = props;
  const mappedStatus = status && statusMap[status] ? statusMap[status] : '--';
  const hasOptionsOpen = (index === exportsOptionsOpen);

  return (<div className={`row exports-list ${props.error ? 'error' : ''}`}>
    <div>
      <div className='value options col-xs-12 hidden-small-up'>
        <div className={`arrow-outside ${hasOptionsOpen ? 'up' : 'down'}`}>
          <div
            className={`${hasOptionsOpen ? 'arrow-up' : 'arrow-down'} ${props.optionsCanOpen ? '' : 'gray-out-arrow'}`}
            onClick={toggleOpen}
          />
        </div>
        { renderOptions(hasOptionsOpen) }
      </div>
      <div className='value date-exported col-xs-2'>
        {dateCreated}
      </div>
      <div
        className='value export-type col-xs-3 col-sm-4'
      >
        { exportType }
      </div>
      <div
        className='value cost col-xs-3 col-sm-2'
      >
        <span>
          { cost }
        </span>
      </div>
      <div className='value status col-xs-3'>
        { mappedStatus }
      </div>
      <div className='value options col-sm-1 hidden-xs'>
        <div className={`arrow-outside ${hasOptionsOpen ? 'up' : 'down'}`}>
          <div
            className={`${hasOptionsOpen ? 'arrow-up' : 'arrow-down'} ${props.optionsCanOpen ? '' : 'gray-out-arrow'}`}
            onClick={toggleOpen}
          />
        </div>
        { renderOptions(hasOptionsOpen) }
      </div>
    </div>
  </div>
  );
};

DataExport.propTypes = {
  dateCreated: PropTypes.string,
  exportType: PropTypes.string,
  status: PropTypes.string,
  cost: PropTypes.string,
  error: PropTypes.bool,
  index: PropTypes.number,
  exportsOptionsOpen: PropTypes.number,
  openOption: PropTypes.func,
  downloadAsCSV: PropTypes.func,
  id: PropTypes.number,
  braintreeId: PropTypes.string,
  navigateTo: PropTypes.func,
  openDeleteExportModal: PropTypes.func,
  openTab: PropTypes.func,
  optionsCanOpen: PropTypes.bool,
};

export default DataExport;



// WEBPACK FOOTER //
// ./modules/DataExports/components/home/children/dataExport.js